import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/cn';

type FeedbackCardProps = {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  size?: 'default' | 'large';
  className?: string;
};

export function FeedbackCard({
  value,
  onChange,
  disabled = false,
  size = 'default',
  className,
}: FeedbackCardProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'rounded-dg-card border border-slate-200/80 bg-white p-4 shadow-sm dark:border-slate-700/70 dark:bg-slate-900/50',
        className
      )}
    >
      <h3 className="text-dg-card-title font-semibold text-slate-900 dark:text-white">
        {t('audit.gradeStudio.feedbackTitle')}
      </h3>
      <label htmlFor="dg-grade-feedback" className="sr-only">
        {t('audit.editor.feedbackLabel')}
      </label>
      <textarea
        id="dg-grade-feedback"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        rows={size === 'large' ? 8 : 5}
        placeholder={t('audit.gradeStudio.feedbackPlaceholder')}
        className={cn(
          'mt-3 w-full resize-y rounded-dg-control border border-slate-200/90 bg-white p-3 text-dg-body text-slate-900 outline-none placeholder:text-slate-400 focus:border-dg-accent-grade/50 focus:ring-2 focus:ring-dg-accent-grade/15 disabled:opacity-50 dark:border-slate-600 dark:bg-slate-950 dark:text-white dark:placeholder:text-slate-500',
          size === 'large' ? 'min-h-[min(40vh,280px)]' : 'min-h-[120px]'
        )}
      />
    </div>
  );
}
